/* PDP only (loaded by sections/main-product.liquid): the sticky bar's variant dropdown and the colour / size swatches of the product form
   follow each other: choosing in the bar chooses the same colour and size in the form, choosing in the form changes the bar */
(function () {
  if (!document.body.classList.contains('product')) return;

  var select;
  var applying = false;

  function group(name) {
    return document.querySelector('product-info:not(quick-add-modal product-info) [option-name="' + name + '"]');
  }

  function itemFor(name, value) {
    var g = group(name);
    return g && g.querySelector('li.swatch-view-item[orig-value="' + value.replace(/"/g, '\\"') + '"]');
  }

  function isChosen(item) {
    if (!item) return false;
    return item.getAttribute('aria-checked') === 'true' || !!item.querySelector('.swatch-selected');
  }

  // the product form shows its "Please select your size" button until the visitor has chosen a size (the swatch app marks one by itself)
  function sizeChosen() {
    var button = document.querySelector('product-info:not(quick-add-modal product-info) #size-disable-button');
    return !button || /none/.test(button.getAttribute('style') || '');
  }

  function chosen(name) {
    if (name === 'Size' && !sizeChosen()) return null;
    var g = group(name);
    var item = g && g.querySelector('li.swatch-view-item[aria-checked="true"], li.swatch-view-item .swatch-selected');
    var li = item && (item.matches('li') ? item : item.closest('li'));
    return li ? li.getAttribute('orig-value') : null;
  }

  function press(item) {
    var target = item.querySelector('.star-set-btn, .swatch-selector, .swatch-image-wrapper') || item;
    target.click();
  }

  // bar -> form
  function onBarChange() {
    var option = select.options[select.selectedIndex];
    var color = option.getAttribute('data-color');
    var size = option.getAttribute('data-size');
    applying = true;

    var colorItem = color && itemFor('Color', color);
    if (colorItem && !isChosen(colorItem)) press(colorItem);

    // the swatch app redraws its sizes after a colour change: press the size once that has happened
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var sizeItem = size && itemFor('Size', size);
      if (sizeItem && (!colorItem || isChosen(colorItem) || tries > 6)) {
        if (!isChosen(sizeItem)) press(sizeItem);
        clearInterval(timer);
        setTimeout(function () { applying = false; }, 600);
      } else if (tries > 20) {
        clearInterval(timer);
        applying = false;
      }
    }, 150);
  }

  // form -> bar
  function syncFromForm() {
    if (applying) return;
    var color = chosen('Color');
    var size = chosen('Size');
    var placeholder = select.querySelector('option[data-placeholder]');
    // no size chosen (e.g. after a colour change): the bar goes back to its "Please select size"
    if (placeholder && !size) {
      if (select.value !== placeholder.value) {
        placeholder.selected = true;
        select.dispatchEvent(new Event('input'));
      }
      return;
    }
    if (!color) return;
    var match = Array.prototype.find.call(select.options, function (o) {
      return o.getAttribute('data-color') === color && (!size || o.getAttribute('data-size') === size);
    });
    if (match && select.value !== match.value) {
      select.value = match.value;
      select.dispatchEvent(new Event('input'));
    }
  }

  function init() {
    select = document.getElementById('variant-selector-sticky');
    if (!select) return;
    select.addEventListener('change', onBarChange);
    document.addEventListener('click', function (event) {
      if (!event.target.closest('product-info [option-name="Color"], product-info [option-name="Size"]')) return;
      setTimeout(syncFromForm, 500);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
